'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _TimezoneTypes = require('../constants/TimezoneTypes');

var _TimezoneTypes2 = _interopRequireDefault(_TimezoneTypes);

var _formatShortDate = require('../utils/formatShortDate');

var _formatShortDate2 = _interopRequireDefault(_formatShortDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var extraFormats = {
  'short-date': _formatShortDate2.default
};

exports.default = _react2.default.createClass({
  displayName: 'FormattedDateTime',

  propTypes: {
    format: _react.PropTypes.string,
    type: _react.PropTypes.oneOf([_TimezoneTypes2.default.PORTAL, _TimezoneTypes2.default.USER, _TimezoneTypes2.default.UTC]),
    value: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.number, _react.PropTypes.array]).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      type: _TimezoneTypes2.default.PORTAL
    };
  },
  render: function render() {
    var _props = this.props,
        value = _props.value,
        format = _props.format,
        type = _props.type;

    var specialFormatter = extraFormats[format];
    var date = '';
    if (specialFormatter) {
      date = specialFormatter(value, type);
    } else {
      date = _I18n2.default.moment[type](value).format(format);
    }

    return _react2.default.createElement(
      'span',
      null,
      date
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.233/js/components/FormattedDateTime.js
// module id = 292
// module chunks = 0